import {
  Component,
  Input,
  Output,
  ChangeDetectionStrategy,
  SimpleChanges,
  OnChanges,
  EventEmitter,
  ViewChild,
  ElementRef,
} from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
} from '@angular/forms';
import {
  GroupAPI,
  Report,
  PermissionAPI,
  ReportTemplateAPI,
  ReportService,
} from '../../services/report.service';
import { FieldConfig, FieldToggleOnVal } from '../../model/field-interface';
import { enumReportType } from '../../model/types/report-type.enum';
import { enumReportFormat } from '../../model/types/report-format.enum';
import swal from 'sweetalert2';
import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogueComponent } from '../confirm-dialogue/confirm-dialogue.component';
import { ReportGroupComponent } from './report-group.component';
import { ReportTemplateComponent } from './report-template.component';
import { enumReportSummaryType } from '../../model/types/report-summary-type.enum';
import { ReportSummaryField } from '../../model/report-summary-field';

@Component({
  selector: 'auth-suite-softsplice-co-za-report-config-ui',
  standalone: false,
  templateUrl: './report-config.component.html',
  styleUrls: ['./report-config.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReportConfigComponent implements OnChanges {
  // activeTab: number = 1;
  _saveBtnstate = false;
  // private _reportId: number;

  // Container component passes the client object for update to this Presentation component
  public _report: Report | undefined;
  private _saveResponse = '';
  public _showMsg = false;
  public _message = '';
  public _groups: GroupAPI = { groups: [] };
  public _templates: ReportTemplateAPI = { templates: [] };
  public _permissions: PermissionAPI = { permissions: [] };
  public mdenumReportType = enumReportType;
  public mdenumReportFormat = enumReportFormat;
  public mdenumsummaryTypes = enumReportSummaryType;

  // For Container component to set save Button state

  @Input() set saveBtnstate(state: boolean) {
    console.log(`ui -- saveBtnstate: ${state}`);
    this._saveBtnstate = state;
  }

  @Input() set report(reportObj: Report | undefined) {
    console.log(`ui -- reportObj: ${reportObj}`);
    this._report = reportObj;
  }

  @Input() set groups(groupObjs: GroupAPI) {
    this._groups = groupObjs;
  }

  @Input() set templates(templateObjs: ReportTemplateAPI) {
    this._templates = templateObjs;
  }

  @Input() set permissions(permissionObjs: PermissionAPI) {
    this._permissions = permissionObjs;
  }

  // Container component passes the CreateResponse to this Presentation component
  @Input() set saveResponse(response: string) {
    console.log(`ui -- createResponse: ${response}`);
    this._saveResponse = response;
  }

  // Container component passes the showmessageflag to this Presentation component
  @Input() set showMsg(show: boolean) {
    console.log(`ui -- showMsg: ${show}`);
    this._showMsg = show;
  }

  @Input() set message(msg: string) {
    console.log(`ui -- message: ${msg}`);
    this._message = msg;
  }

  // Presentation component emitting events to Container component to Save Report
  @Output() save: EventEmitter<Report> = new EventEmitter();

  @Output() close: EventEmitter<boolean> = new EventEmitter();

  @Output() delete: EventEmitter<Report> = new EventEmitter();

  @Output() formNotSaved: EventEmitter<boolean> = new EventEmitter();

  // get inputFieldsDynamic() {
  //   return this.reportForm.get('inputFields') as FormArray;
  // }

  // get toggleFieldsDynamic() {
  //   return this.reportForm.get('toggleFields') as FormArray;
  // }

  inputTypes = ['', 'text', 'email', 'password'];
  controlTypes = [
    'input',
    'button',
    'select',
    'date',
    'radiobutton',
    'checkbox',
    'file',
  ];

  report_validation_messages = {
    reportName: [{ type: 'required', message: 'Report Name is required' }],
    label: [{ type: 'required', message: 'Input Field Label is required' }],
    fieldName: [
      { type: 'required', message: 'Field Name to toggle is required' },
    ],
    reportType: [{ type: 'required', message: 'Report Type is required' }],
    reportActive: [{ type: 'required', message: 'Report Active is required' }],
    reportFormatsAllowed: [
      { type: 'required', message: 'Report Formats Allowed is required' },
    ],
    defaultReportFormat: [
      { type: 'required', message: 'Default Report Format is required' },
    ],
    summaryFieldName: undefined,
    summaryType: undefined,
    displayName: undefined,
  };

  reportForm: FormGroup = this.fb.group({
    id: [{ value: '', disabled: true }],
    reportName: [{ value: '', disabled: false }, [Validators.required]],
    description: [{ value: '', disabled: false }],
    shortId: [{ value: '', disabled: false }],
    reportTemplateName: [{ value: '', disabled: false }],
    jobOnServer: [{ value: false, disabled: false }],
    reportPermission: [{ value: '', disabled: false }],
    filterAllowedGIDAccess: [{ value: false, disabled: false }],
    reportActive: [{ value: false, disabled: false }, [Validators.required]],
    reportType: [{ value: '', disabled: false }, [Validators.required]],
    reportSQL: [{ value: '', disabled: false }],
    recordDate: [{ value: '', disabled: true }],
    recordTime: [{ value: '', disabled: true }],
    group: [{ value: '', disabled: false }, [Validators.required]],
    reportFormatsAllowed: [
      { value: '', disabled: false },
      [Validators.required],
    ],
    defaultReportFormat: [
      { value: '', disabled: false },
      [Validators.required],
    ],
    inputFields: this.fb.array([]),
    summaryFields: this.fb.array([]),
    landscape: [{ value: true, disabled: false }],
    uacUser: [{ value: '', disabled: true }],
  });

  inputFieldsGroup: FormGroup = this.fb.group({
    label: [{ value: '', disabled: false }, [Validators.required]],
    name: [{ value: '', disabled: false }, [Validators.required]],
    inputType: [{ value: '', disabled: false }],
    options: [{ value: '', disabled: false }],
    multipleSelect: [{ value: false, disabled: false }],
    ignoreOnFilter: [{ value: false, disabled: false }],
    collections: [{ value: '', disabled: false }],
    type: [{ value: '', disabled: false }, [Validators.required]],
    value: [{ value: '', disabled: false }],
    toggleFields: this.fb.array([]),
  });

  toggleFieldsGroup: FormGroup = this.fb.group({
    fieldName: [{ value: '', disabled: false }, [Validators.required]],
    values: [{ value: '', disabled: false }, [Validators.required]],
    show: [{ value: false, disabled: false }],
    hide: [{ value: false, disabled: false }],
  });

  get inputFields(): FormArray {
    return this.reportForm.get('inputFields') as FormArray;
  }

  get reportF() {
    return this.reportForm.controls;
  }
  get summaryFields(): FormArray {
    return this.reportForm.get('summaryFields') as FormArray;
  }

  public REPORT_HELP = [
    {
      label: 'GID Filter',
      description: 'Include the GlobalID Filter use the following ',
      code: '--GID-- AND GIDField %INLIST ? --/GID--',
    },
    {
      label: 'Optional Input Fields',
      description: 'Enclose field in ',
      code: '--optional:CreationDateFrom-- Field = ? --/optional:CreationDateFrom--',
    },
    {
      label: 'Ask Report and Schedule report',
      description:
        'You can add 2 where clauses, 1 for running the report from this site and the other to schedule the report. ' +
        'Enclose where clauses in ',
      code:
        'Select  .... <br>--RUN_WHERE-- <br>Where  ..... <br>--/RUN_WHERE-- ' +
        '<br>  <br> --SCHEDULE_WHERE-- <br>Where  ..... <br>--/SCHEDULE_WHERE--',
    },
  ];

  constructor(
    private fb: FormBuilder,
    private dialog: MatDialog,
    private reportService: ReportService
  ) {
    this.reportForm = this.fb.group({
      id: [{ value: '', disabled: true }],
      reportName: [{ value: '', disabled: false }, [Validators.required]],
      description: [{ value: '', disabled: false }],
      shortId: [{ value: '', disabled: false }],
      reportTemplateName: [{ value: '', disabled: false }],
      jobOnServer: [{ value: false, disabled: false }],
      landscape: [{ value: true, disabled: false }],
      reportPermission: [{ value: '', disabled: false }],
      filterAllowedGIDAccess: [{ value: false, disabled: false }],
      reportActive: [{ value: '', disabled: false }, [Validators.required]],
      reportType: [{ value: '', disabled: false }, [Validators.required]],
      reportSQL: [{ value: '', disabled: false }],
      recordDate: [{ value: '', disabled: true }],
      recordTime: [{ value: '', disabled: true }],
      uacUser: [{ value: '', disabled: true }],
      group: [{ value: '', disabled: false }],
      reportFormatsAllowed: [
        { value: '', disabled: false },
        [Validators.required],
      ],
      defaultReportFormat: [
        { value: '', disabled: false },
        [Validators.required],
      ],
      inputFields: this.fb.array([]),
      summaryFields: this.fb.array([]),
    });

    this.inputFieldsFormGroup();
    this.toggleFieldsFormGroup();
    this.summaryFieldsFormGroup();
    this.createForm();
  }

  ngOnChanges(changes: SimpleChanges): void {
    // console.log(`MandateRegisterSuspend changes ${JSON.stringify(changes)}`)
    for (const prop of Object.keys(changes)) {
      console.log(`changed-prop: ${prop}`);
      console.log(changes[prop].currentValue);
    }
    if (changes['report']) {
      if (changes['report'].currentValue !== undefined) {
        this.createForm();
        this.patchReportForm();
      }
    }
    this.reportForm.statusChanges.subscribe((val) => {
      // console.log('val changes');
      if (!this.reportForm.pristine) {
        this.formNotSaved.emit(true);
      }
      // console.log(`touched ${this.reportForm.touched} pristine ${this.reportForm.pristine}`);
    });
  }

  submit() {
    const newReport: Report = Object.assign({}, this.reportForm.getRawValue());
    // newReport.reportPermission = newReport.reportPermission.toString();
    console.log('submit');
    this.save.emit(newReport);
    this.reportForm.markAsPristine({ onlySelf: true });
    this.reportForm.markAsUntouched({ onlySelf: true });
    this.formNotSaved.emit(false);
  }

  deleteReport() {
    const delReport: Report = Object.assign({}, this.reportForm.getRawValue());
    this.delete.emit(delReport);
  }

  public createForm() {
    this.showMsg = false;
    this._saveBtnstate = false;
    // this.reportForm.reset();
    console.log(this.reportForm);
  }

  private patchReportForm() {
    this.reportForm.patchValue({
      id: this._report?.id,
      reportName: this._report?.reportName,
      description: this._report?.description,
      shortId: this._report?.shortId,
      reportTemplateName: this._report?.reportTemplateName,
      jobOnServer: this._report?.jobOnServer,
      reportPermission: this._report?.reportPermission,
      filterAllowedGIDAccess: this._report?.filterAllowedGIDAccess,
      reportActive: this._report?.reportActive,
      landscape: this._report?.landscape,
      reportType: this._report?.reportType,
      reportSQL: this._report?.reportSQL,
      recordDate: this._report?.recordDate,
      recordTime: this._report?.recordTime,
      uacUser: this._report?.uacUser,
      group: this._report?.group,
      reportFormatsAllowed: this._report?.reportFormatsAllowed,
      defaultReportFormat: this._report?.defaultReportFormat,
    });

    if (this._report?.inputFields !== undefined) {
      this.reportForm.setControl(
        'inputFields',
        this.setInputFieldsFormGroup(this._report?.inputFields)
      );
    } else {
      this.reportForm.setControl('inputFields', this.fb.array([]));
    }

    if (this._report?.summaryFields !== undefined) {
      this.reportForm.setControl(
        'summaryFields',
        this.setSummaryFieldsFormGroup(this._report?.summaryFields)
      );
    } else {
      this.reportForm.setControl('summaryFields', this.fb.array([]));
    }

    this.reportForm.markAsPristine({ onlySelf: true });
    this.reportForm.markAsUntouched({ onlySelf: true });
  }

  inputFieldsFormGroup(): FormGroup {
    return this.fb.group({
      label: [{ value: '', disabled: false }, [Validators.required]],
      name: [{ value: '', disabled: false }, [Validators.required]],
      inputType: [{ value: '', disabled: false }],
      options: [{ value: '', disabled: false }],
      optionValues: [{ value: '', disabled: false }],
      multipleSelect: [{ value: false, disabled: false }],
      ignoreOnFilter: [{ value: false, disabled: false }],
      required: [{ value: false, disabled: false }],
      collections: [{ value: '', disabled: false }],
      type: [{ value: '', disabled: false }, [Validators.required]],
      value: [{ value: '', disabled: false }],
      toggleFields: this.fb.array([]),
    });
  }

  setInputFieldsFormGroup(inputFields: FieldConfig[]): FormArray {
    const formArray = new FormArray<any>([]);
    inputFields.forEach((field) => {
      const thisOptions =
        field.options !== undefined ? field.options.toString() : '';
      const thisOptionValues =
        field.optionValues !== undefined ? field.optionValues.toString() : '';
      const inputFieldGroup = this.fb.group({
        label: [{ value: field.label, disabled: false }, [Validators.required]],
        name: [{ value: field.name, disabled: false }, [Validators.required]],
        inputType: [{ value: field.inputType, disabled: false }],
        options: [{ value: thisOptions, disabled: false }],
        optionValues: [{ value: thisOptionValues, disabled: false }],
        multipleSelect: [{ value: field.multipleSelect, disabled: false }],
        ignoreOnFilter: [{ value: field.ignoreOnFilter, disabled: false }],
        required: [{ value: field.required, disabled: false }],
        collections: [{ value: field.collections, disabled: false }],
        type: [{ value: field.type, disabled: false }, [Validators.required]],
        value: [{ value: field.value, disabled: false }],
        toggleFields: this.fb.array([]),
      });
      if (field.toggleFields !== undefined) {
        inputFieldGroup.setControl(
          'toggleFields',
          this.setToggleFieldsFormGroup(field.toggleFields)
        );
      }

      formArray.push(inputFieldGroup);
    });

    this.reportForm.markAsPristine({ onlySelf: true });
    this.reportForm.markAsUntouched({ onlySelf: true });

    return formArray;
  }

  toggleFieldsFormGroup(): FormGroup {
    return this.fb.group({
      fieldName: [{ value: '', disabled: false }, [Validators.required]],
      values: [{ value: '', disabled: false }, [Validators.required]],
      show: [{ value: '', disabled: false }],
      hide: [{ value: '', disabled: false }],
    });
  }

  setToggleFieldsFormGroup(toggleFields: FieldToggleOnVal[]): FormArray {
    const formArray = new FormArray<any>([]);
    toggleFields.forEach((field) => {
      formArray.push(
        this.fb.group({
          fieldName: [
            { value: field.fieldName, disabled: false },
            [Validators.required],
          ],
          values: [
            { value: field.values, disabled: false },
            [Validators.required],
          ],
          show: [{ value: field.show, disabled: false }],
          hide: [{ value: field.hide, disabled: false }],
        })
      );
    });

    this.reportForm.markAsPristine({ onlySelf: true });
    this.reportForm.markAsUntouched({ onlySelf: true });

    return formArray;
  }

  getCurrentToggleFieldsGroup(index: number): FormArray {
    return this.inputFields.at(index).get('toggleFields') as FormArray;
  }

  summaryFieldsFormGroup(): FormGroup {
    return this.fb.group({
      summaryFieldName: [{ value: '', disabled: false }],
      displayName: [{ value: '', disabled: false }],
      summaryType: [{ value: '', disabled: false }],
    });
  }

  setSummaryFieldsFormGroup(summaryFields: ReportSummaryField[]): FormArray {
    const formArray = new FormArray<any>([]);
    summaryFields.forEach((field) => {
      formArray.push(
        this.fb.group({
          summaryFieldName: [
            { value: field.summaryFieldName, disabled: false },
          ],
          displayName: [{ value: field.displayName, disabled: false }],
          summaryType: [{ value: field.summaryType, disabled: false }],
        })
      );
    });
    this.reportForm.markAsPristine({ onlySelf: true });
    this.reportForm.markAsUntouched({ onlySelf: true });

    return formArray;
  }

  addFieldButtonClick() {
    // (<FormArray>this.reportForm.get('inputFields')).push(this.inputFieldsFormGroup());
    // console.log(this.inputFields);
    this.inputFields.push(this.inputFieldsFormGroup());
  }

  removeFieldButtonClick(index: number) {
    this.inputFields.removeAt(index);
  }

  addSummaryButtonClick() {
    this.summaryFields.push(this.summaryFieldsFormGroup());
  }

  removeSummaryButtonClick(index: number) {
    this.summaryFields.removeAt(index);
  }

  addToggleFieldButtonClick(index: number) {
    const inputFieldToggleFields = this.inputFields
      .at(index)
      .get('toggleFields') as FormArray;
    const toggleGroup = this.toggleFieldsFormGroup();
    inputFieldToggleFields.push(toggleGroup);
  }

  removeToggleFieldButtonClick(inputFieldIndex: number, index: number) {
    const inputFieldToggleFields = this.inputFields
      .at(inputFieldIndex)
      .get('toggleFields') as FormArray;
    inputFieldToggleFields.clearAsyncValidators();
    inputFieldToggleFields.removeAt(index);
  }

  getAllErrors(form: FormGroup | FormArray): { [key: string]: any } | null {
    let hasError = false;
    const result = Object.keys(form.controls).reduce((acc, key) => {
      const control = form.get(key);
      const errors =
        control instanceof FormGroup || control instanceof FormArray
          ? this.getAllErrors(control)
          : control?.errors;
      if (errors) {
        acc[key] = errors;
        hasError = true;
      }
      return acc;
    }, {} as { [key: string]: any });
    return hasError ? result : null;
  }

  public objectComparisonFunction = function (
    option: any,
    value: any
  ): boolean {
    console.log(value);
    return value === null ? false : option.id === value.id;
  };

  toggleShowHide(evt: any, inputFieldIndex: number, j: number) {
    console.log(evt.target.checked);
    console.log(evt.target.id);
    console.log(evt);
    console.log(`i: ${inputFieldIndex} j: ${j}`);
    const inputFieldToggleFields = this.inputFields
      .at(inputFieldIndex)
      .get('toggleFields') as FormArray;

    if (evt.target.id.startsWith('show')) {
      if (evt.target.checked) {
        inputFieldToggleFields.at(j).patchValue({ hide: false });
      } else {
        inputFieldToggleFields.at(j).patchValue({ hide: true });
      }
    }

    if (evt.target.id.startsWith('hide')) {
      if (evt.target.checked) {
        inputFieldToggleFields.at(j).patchValue({ show: false });
      } else {
        inputFieldToggleFields.at(j).patchValue({ show: true });
      }
    }
  }

  showSwal(type: string) {
    if (type === 'warning-message-and-confirmation') {
      swal
        .fire({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          icon: 'warning',
          target: 'deleteDialogue',
          showCancelButton: true,
          customClass: {
            confirmButton: 'btn btn-success',
            cancelButton: 'btn btn-danger',
          },
          confirmButtonText: 'Yes, Delete this Report!',
          buttonsStyling: false,
        })
        .then((result) => {
          if (result.value) {
            this.deleteReport();
            this.createForm();
            this._report = undefined;
          }
        });
    }
  }

  resetForm() {
    this.report = undefined;
    this.reportForm.reset({ landscape: { value: true, disabled: false } });
    while (this.inputFields.length) {
      this.inputFields.removeAt(this.inputFields.length - 1);
    }

    while (this.summaryFields.length) {
      this.summaryFields.removeAt(this.summaryFields.length - 1);
    }

    this.createForm();
  }

  drop(event: CdkDragDrop<FormGroup[]>) {
    console.log(
      `currentIndex:${event.currentIndex}  previousIndex:${event.previousIndex}`
    );
    const dir = event.currentIndex > event.previousIndex ? 1 : -1;

    const from = event.previousIndex;
    const to = event.currentIndex;

    const temp = this.inputFields.at(from);
    for (let i = from; i * dir < to * dir; i = i + dir) {
      const current = this.inputFields.at(i + dir);
      this.inputFields.setControl(i, current);
    }
    this.inputFields.setControl(to, temp);
  }

  dropSummary(event: CdkDragDrop<FormGroup[]>) {
    console.log(
      `currentIndex:${event.currentIndex}  previousIndex:${event.previousIndex}`
    );
    const dir = event.currentIndex > event.previousIndex ? 1 : -1;

    const from = event.previousIndex;
    const to = event.currentIndex;

    const temp = this.summaryFields.at(from);
    for (let i = from; i * dir < to * dir; i = i + dir) {
      const current = this.summaryFields.at(i + dir);
      this.summaryFields.setControl(i, current);
    }
    this.summaryFields.setControl(to, temp);
  }

  closeForm() {
    if (!this.reportForm.pristine) {
      // const confirmClose =  confirm('Your changes are unsaved!! Do you like to exit');

      const dialogRef = this.dialog.open(ConfirmDialogueComponent, {
        data: {
          message: 'Report Not Saved, Do you want to discard unsaved changes?',
        },
      });

      return dialogRef.afterClosed().subscribe((result) => {
        this.close.emit(!result);
        this.formNotSaved.emit(!result);
      });

      // swal({
      //   title:  'Your changes are unsaved?',
      //   text:  'You won\'t be able to revert this!',
      //   type:  'warning',
      //   showCancelButton:  true,
      //   confirmButtonClass:  'btn btn-success',
      //   cancelButtonClass:  'btn btn-danger',
      //   confirmButtonText:  'Yes, do not save it!',
      //   buttonsStyling:  false
      // }).then(result => {
      //   console.log(`alert val: ${result.value}`);
      //   if (result.value) {
      //     this.close.emit(false);
      //   }
      // });
      // if (confirmClose) { this.close.emit(false); }
    } else {
      this.resetForm();
      this.close.emit(false);
      return false;
    }
  }

  formState(form: FormGroup) {
    console.log(`pristine ${form.pristine}`);
    console.log(`touched ${form.touched}`);
  }

  showGroupDialogue() {
    const dialogRef = this.dialog.open(ReportGroupComponent);
    dialogRef.afterClosed().subscribe((resp) => {
      this.reportService.getGroups().subscribe((groupResp) => {
        this.groups = groupResp;
      });
    });
  }

  showTemplateDialogue() {
    const dialogRef = this.dialog.open(ReportTemplateComponent);
    dialogRef.afterClosed().subscribe((resp) => {
      this.reportService.getTemplates().subscribe((templateResp) => {
        this.templates = templateResp;
      });
    });
  }
}
